/*
 * File containing utility methods for supporting the description fields
 * rendered by RTE on mvc pages
 */
import React from 'react';
import sanitizeInnerHtml from 'nucleus-text/sanitize/sanitizeInnerHtml';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';

const htmlIndicatingDiv = '<div class="ag87-crtemvc-hsbk">';
/**
 * this checks if the description text entered by the user, is plainText without any styling
 * or html generated by styling the text.
 * @param text
 * @returns {boolean}
 */
export function isStyledDescription(text) {
  return text && text.startsWith(htmlIndicatingDiv);
}

/**
 * pulling out the common code for rendering description sections of Session, SessionGroup.
 * It performs the check if the description is styled using RTE from planner side and
 * renders the description accordingly.
 * @param props
 * @param description
 * @param resolutionKey
 * @param testId
 */
export function renderDescriptionSection(props, description, resolutionKey = 'description', testId = '-description') {
  if (isStyledDescription(description)) {
    return (<div
      {...resolve(props, resolutionKey)}
      {...resolveTestId(props, testId)}
      dangerouslySetInnerHTML={sanitizeInnerHtml(props.translate(description))} />);
  }
  return (<div
    {...resolve(props, resolutionKey)}
    {...resolveTestId(props, testId)}>
    { props.translate(description) }
  </div>);
}
